<div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-16">
  <div class="flex-vertical gap-16 width-100pc">
    @if (partenaireOptions.length > 0) {
      <div class="flex-horizontal flex-center gap-16">
        <oui-select
          class="thirdWidth"
          [options]="partenaireOptions"
          [control]="partenaireControl"
          label="Sélectionner un partenaire">
        </oui-select>
        @if (selectedOperationsPerPartenaireList.length != operationsPerPatenaireList.length) {
          <oui-button
            (click)="resetPartenaireSelection()"
            type="text"
            >Afficher tous les partenaires</oui-button
            >
          }
        </div>
      }
      @for (entry of selectedOperationsPerPartenaireList; track entry) {
        <oui-accordion [expanded]="true">
          <oui-accordion-header class="padding-vertical-8">
            <oui-accordion-title class="subtitle-1">{{
              getPartenaireTitleById(entry.key, entry.value.operations.length)
            }}</oui-accordion-title>
          </oui-accordion-header>
          <div class="flex-vertical">
            <app-operations-table
          [receivedData]="{
            loading: entry.value.loading,
            data: { items: entry.value.operations, totalCount: entry.value.operations.length },
          }"
              (requestNewPage)="getAllOperations()"
              [(paginationParams)]="paginationParams"
              [columnSelection]="columnSelection"
              (onOperationRowClick)="onRowClick($event)"
              [withSelects]="!entry.value.loading"
              (onSelectionActionClicked)="onSelectionActionClicked($event, entry.key, entry.value)"
              [withPaginator]="false"
              [withTotalNumberDisplayed]="false"
              [fetchOnInit]="false"
              [selectionActions]="selectionActions"
              [withClickableRow]="false"
              [withRefresh]="false">
            </app-operations-table>
          </div>
        </oui-accordion>
      }
      @if (partenaireOptions.length == 0 || operationsPerPatenaireList.length == 0) {
        <div class="etat-vide-container">
          @if (!loading) {
            <oui-etat-vide
              title="Aucune opération disponible pour générer un bordereau"
            icon="folder_open"></oui-etat-vide>
          }
          @if (loading) {
            <oui-loading></oui-loading>
          }
        </div>
      }
    </div>
  </div>
